import apiService from './api';

const BASEURL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const variantService = {
  // Get all variants with pagination
  getVariants: async (pageNumber = 1, size = 10, search = '') => {
    const params = { 
      PageNumber: pageNumber, 
      size: size 
    };
    
    if (search) params.search = search;
    
    return apiService.get(`${BASEURL}/Variant/Pagination`, params);
  },

  getAllVariants: async (search = '') => {
    return apiService.get(`${BASEURL}/Variant`);
  },
  
  // Get single variant by ID
  getVariant: async (id) => {
    return apiService.get(`${BASEURL}/Variant/${id}`);
  },
  
  // Create new variant with the specific API format
  createVariant: async (variantData) => {
    // Format data according to API requirements
    const formattedData = {
      entet: {
        id: 0,  // Backend will assign real ID
        name: variantData.name,
      },
      line: variantData.values.map(value => ({
        id: 0,  // Backend will assign real ID
        value: value,
        variantId: 0  // Backend will assign real ID
      }))
    };
    
    return apiService.post(`${BASEURL}/Variant`, formattedData);
  },
  
  // Update variant with the exact format needed by the API
  updateVariant: async (id, variantData) => {
    // Format data according to API requirements
    const formattedData = {
      entet: {
        id: variantData.id,
        name: variantData.name
      },
      line: variantData.values.map(value => {
        const formattedValue = {
          value: value.value || value,
          variantId: variantData.id
        };
        if (value.id) formattedValue.id = value.id;
        return formattedValue;
      })
    };
    
    return apiService.put(`${BASEURL}/Variant`, formattedData);
  },
  
  // Delete variant
  deleteVariant: async (id) => {
    return apiService.delete(`${BASEURL}/Variant/${id}`);
  },
  
  values: {
    // Add value to variant
    addValue: async (variantId, value) => {
      const formattedData = {
        id: 0,  // Backend will assign real ID
        value: value,
        variantId: variantId
      };
      
      return apiService.post(`${BASEURL}/Variant/${variantId}/values`, formattedData);
    },
    
    // Update value
    updateValue: async (variantId, valueId, valueData) => {
      return apiService.put(`${BASEURL}/Variant/${variantId}/values/${valueId}`, valueData);
    },
    
    // Delete value
    deleteValue: async (variantId, valueId) => {
      return apiService.delete(`${BASEURL}/Variant/${variantId}/values/${valueId}`);
    }
  }
};

export default variantService;